/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import DataTable from "examples/Tables/DataTable";

import { FormControl, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import LoadingModal from "components/LoadingModel/loadingModal";
import MDButton from "components/MDButton";
import CustomText from "components/customtext/customtext";
import Height from "components/height/height";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import swal from "sweetalert";
import { getDriverByID, getReacherOrderByID, updateItemStatusByID } from "utils/api";
import { showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import "./recieveOrder.scss";
let LOGIN_DETAILS
let EMPLOYEE_DETAILS;
const errMsg = {
    color: `red`,
    fontSize: `11px`,
};
function RecieveOrder() {
    const { id } = useParams();
    const [rows, setRows] = useState([]);
    const [atFlag, SetATFlag] = useState(false);
    const [loading, setLoading] = useState(false);
    const [driver, setDriver] = useState([]);
    const [barCodeErr, setBarCodeErr] = useState(false);
    const [notesErr, setNotesErr] = useState(false)
    const [loadPlanVehiclesID, setLoadPlanVehiclesID] = useState("")
    const [validation, setValidation] = useState(false)
    const [itemErr, setitemErr] = useState(false);
    const dispatch = useDispatch();

    const [values, setValues] = React.useState({
        orderNumber: "",
        orderDate: "",
        shipmentType: "",
        paymentType: "",
        senderCity: "",
        receiverCity: "",
        distance: "",
        totalCharges: "",
        barCodeID: "",
        itemQuantity: "",
        notes: "",
    });
    values.orderID = id

    const [valuesLog, setValuesLog] = React.useState({
        assignedDriverID: "",
        jobStatus: "",
        jobStatusNotes: "",
    });

    const handleChange = (name) => (event) => {

        if (event.target.validity.valid) {
            setValues({ ...values, [name]: event.target.value });
        }
    };

    const handleChangeLog = (name) => (event) => {
        setValuesLog({ ...valuesLog, [name]: event.target.value });
    };
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const paramValue = urlParams.get('LoadID')
        setLoadPlanVehiclesID(paramValue)
        values.loadPlanVehiclesID = paramValue
    }, [])

    useEffect(() => {
        if (values.barCodeID !== "" && values.barCodeID !== undefined) {

            let flag = false
            if (values.barCodeID.split("").length !== 10) {
                flag = false
                setBarCodeErr(true)
                return
            } else {
                console.log("dfsfsfsfds", rows)
                for (let data of rows) {
                    if (data.barCodeID === values.barCodeID) {
                        flag = false
                        if (data.receivedQty === "" || data.receivedQty === undefined || data.receivedQty === null) {
                            if (values.itemQuantity < data.numberOfItems) {
                                setValidation(true)
                            } else setValidation(false)
                        } else {
                            if (values.itemQuantity < (values.numberOfItems - data.receivedQty)) {
                                setValidation(true)
                            } else setValidation(false)
                        }
                    }
                }
                if (flag) {
                    swal({
                        title: "Invalid Bar Code",
                        text: " ",
                        icon: "error",
                        color: "red",
                        button: false,
                        timer: 2000,
                    });
                }
                setBarCodeErr(false)



            }
        }

    }, [values.barCodeID, values.itemQuantity])
    let mandateFlag = false

    const updateStatus = async () => {
        try {
            mandateFlag = false


            if (id !== undefined) {

                if (loadPlanVehiclesID !== "" && loadPlanVehiclesID !== undefined) {

                    values.loadPlanVehiclesID = loadPlanVehiclesID
                }

                if (values.barCodeID.toString().trim() === "") {

                    swal({
                        title: "Invalid Bar Code",
                        text: " ",
                        icon: "error",
                        color: "red",
                        button: false,
                        timer: 2000,
                    });

                    mandateFlag = true
                } else if (values.barCodeID.split("").length !== 10) {
                    setBarCodeErr(true)
                    mandateFlag = true
                } else setBarCodeErr(false)

                if (values.itemQuantity.toString().trim() === "") {
                    setitemErr(true)
                    mandateFlag = true

                } else setitemErr(false)


                if (validation) {

                    if (values.notes.toString().trim() === "") {
                        setNotesErr(true)
                        mandateFlag = true

                    } else setNotesErr(false)


                } else setNotesErr(false)

                if (mandateFlag) return


                updateItemStatusByID(values, (data) => {
                    if (data.Result_Status) fetchOrder()
                    showResMsg(data.Result_Status ? genericMessage.updated : data.Result_Message, 1000, data.Result_Status)
                }, dispatch)
            }
        } catch (error) {
            setLoading(false);
            console.log("In Catch of addNewUser==", error);
        }
    };
    LOGIN_DETAILS = JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'));
    values.businessUserID = LOGIN_DETAILS.businessUserID;
    EMPLOYEE_DETAILS = JSON.parse(sessionStorage.getItem('Employee_Details'));
    values.warehouseID = EMPLOYEE_DETAILS.employeeWarehouseLocation;

    useEffect(() => {
        if (id !== undefined) {
            Promise.all([
                fetchOrder(),
                fetchDriver()
            ])
        }
    }, [])

    const fetchOrder = async () => {

        getReacherOrderByID(values, (data) => {
            if (data.Result_Output.length > 0) {
                setValues(data.Result_Output[0]);

                setValues((prevValues) => ({
                    ...prevValues,
                    barCodeID: "",
                    notes: "",
                    itemQuantity: ""
                }));
                setRows(data.Result_Output);
            }

        }, dispatch)
    }




    const fetchDriver = async () => {
        getDriverByID(values, (data) => {
            setDriver(data.Result_Output)
        }, dispatch)
    }

    let driverList = (driver).length > 0
        && (driver).map((item, i) => {
            return (
                <MenuItem key={i} value={item._id}>{item.firstName} {item.lastName}</MenuItem>
            )
        }, this);

    const screenName = "Order Information"
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Height val={30} />
            <Card >
                <PageTitle screenName={screenName} />
                <Grid container px={2}>
                    <Grid item xs={12} md={3} lg={12} sx={{ display: "flex", justifyContent: "end" }}>
                        <Link to={"/warehouseDashboard"} >
                            <MDButton color="warning">Back</MDButton>
                        </Link>
                    </Grid>
                </Grid>
                <Grid container px={2} mt={4} columnSpacing={2} justifyContent={"space-between"}>
                    <Grid item xs={4.5}>
                        <Card sx={{ backgroundColor: "aliceblue" }}>
                            <Grid container>
                                <Grid
                                    item
                                    xs={6}
                                    style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
                                    pl={5}
                                    pt={2}
                                >
                                    <CustomText type="p" size={17} style={{ color: "black" }}>
                                        Order Number:
                                    </CustomText>
                                </Grid>
                                <Grid item xs={6} style={{ marginBottom: "2px" }} pl={5}
                                    pt={2}>
                                    <CustomText type="b" size={16} style={{ color: "black" }}>
                                        {values.orderNumber}
                                    </CustomText>
                                </Grid>
                                <Grid
                                    item
                                    xs={6}
                                    style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
                                    pl={5}
                                    pb={2}
                                >
                                    <CustomText type="p" size={17} style={{ color: "black" }}>
                                        Order Date:
                                    </CustomText>
                                </Grid>
                                <Grid item xs={6} style={{ marginBottom: "2px" }} pl={5} pb={2}>
                                    <CustomText type="b" size={16} style={{ color: "black" }}>
                                        {values.orderDate}
                                    </CustomText>
                                </Grid>
                            </Grid>
                        </Card>
                    </Grid>
                    <Grid item xs={4.5}>
                        <Card sx={{ backgroundColor: "aliceblue" }}>
                            <Grid container>
                                <Grid
                                    item
                                    xs={6}
                                    style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
                                    pl={5}
                                    pt={2}
                                >
                                    <CustomText type="p" size={17} style={{ color: "black" }}>
                                        Consignment Type:
                                    </CustomText>
                                </Grid>
                                <Grid item xs={6} style={{ marginBottom: "2px" }} pl={5}
                                    pt={2}>
                                    <CustomText type="b" size={16} style={{ color: "black" }}>{values.shipmentType} </CustomText>
                                </Grid>
                                <Grid
                                    item
                                    xs={6}
                                    style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
                                    pl={5}
                                    pb={2}
                                >
                                    <CustomText type="p" size={17} style={{ color: "black" }}>
                                        Payment Type:
                                    </CustomText>
                                </Grid>
                                <Grid item xs={6} style={{ marginBottom: "2px" }} pl={5}
                                    pb={2}>
                                    <CustomText type="b" size={16} style={{ color: "black" }}>{values.paymentType}</CustomText>
                                </Grid>
                            </Grid>
                        </Card>
                    </Grid>
                </Grid>

                <Grid container px={2} mt={4} columnSpacing={2} justifyContent={"space-between"}>
                    <Grid item xs={4.5} pl={5}>
                        <Card sx={{ backgroundColor: "aliceblue" }}>
                            <Grid item xs={8} pl={5} style={{ display: "flex", alignItems: "center" }} pt={3}>
                                <CustomText type="b" size={17} style={{ color: "black" }}  >
                                    Sender Address:
                                </CustomText>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                pl={5}
                                style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
                            >
                                <CustomText type="p" size={17} style={{ color: "black" }}>
                                    {values.senderName}
                                </CustomText>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                pl={5}
                                style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
                            >
                                <CustomText type="p" size={17} style={{ color: "black" }}>
                                    {values.senderStreetAddress}
                                </CustomText>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                pl={5}
                                style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
                            >
                                <CustomText type="p" size={17} style={{ color: "black" }}>
                                    {values.senderCity} , {values.senderZipCode}
                                </CustomText>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                pl={5}
                                style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
                            >
                                <CustomText type="p" size={17} style={{ color: "black" }}>

                                </CustomText>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                pl={5}
                                style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
                            >
                                <CustomText type="p" size={17} style={{ color: "black" }}>

                                    {values.senderContactNumber}
                                </CustomText>
                            </Grid>

                            <Height val={28} />
                        </Card>
                    </Grid>

                    <Grid item xs={4.5}>
                        <Card sx={{ backgroundColor: "aliceblue" }}>
                            <Grid
                                item
                                xs={8}
                                pl={5}
                                pt={3}
                                style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
                            >
                                <CustomText type="b" size={17} style={{ color: "black" }}>
                                    Receiver Address:
                                </CustomText>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                pl={5}
                                style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
                            >
                                <CustomText type="p" size={17} style={{ color: "black" }}>
                                    {values.receiverName}
                                </CustomText>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                pl={5}
                                style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
                            >
                                <CustomText type="p" size={17} style={{ color: "black" }}>
                                    {values.receiverStreetAddress}<br /> {values.receiverCity} , {values.receiverZipCode}
                                </CustomText>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                pl={5}
                                style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
                            >
                                <CustomText type="p" size={17} style={{ color: "black" }}>

                                </CustomText>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                pl={5}
                                style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
                            >
                                <CustomText type="p" size={17} style={{ color: "black" }}>
                                    {values.receiverContactNumber}
                                </CustomText>
                            </Grid>
                            <Height val={28} />
                        </Card>
                    </Grid>

                </Grid>
                <Grid container px={2} mt={4} columnSpacing={2} justifyContent={"space-between"}>
                    {atFlag &&
                        <><Grid item lg={4}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Last Assigned Driver</InputLabel>

                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    style={{ minHeight: "3em" }}
                                    label="Last Assigned Driver"
                                    disabled
                                    value={valuesLog.assignedDriverID}
                                    onChange={handleChangeLog("assignedDriverID")}
                                >
                                    {driverList}
                                </Select>

                            </FormControl>
                        </Grid>
                            <Grid item lg={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        type="text"
                                        label="Driver Status"
                                        variant="outlined"
                                        fullWidth
                                        disabled
                                        value={valuesLog.jobStatus}
                                        onChange={handleChangeLog("jobStatus")}
                                    >
                                    </TextField>
                                </FormControl>
                            </Grid>
                            <Grid item lg={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        type="text"
                                        label="Driver Notes"
                                        variant="outlined"
                                        fullWidth
                                        disabled
                                        value={valuesLog.jobStatusNotes}
                                        onChange={handleChangeLog("jobStatusNotes")}
                                    >
                                    </TextField>
                                </FormControl>
                            </Grid>
                        </>}
                    <Grid item xs={12} lg={3}>
                        <MDBox component="form" role="form">
                            <MDBox mb={4} xs={12}>
                                <TextField
                                    type="text"
                                    label="Bar Code"
                                    variant="outlined"
                                    fullWidth
                                    inputProps={{
                                        pattern: "^[a-zA-Z0-9 ]+$",
                                        maxLength: 30
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                        }
                                    }}
                                    readOnly
                                    onChange={handleChange("barCodeID")}
                                />
                                {barCodeErr ? <span style={errMsg}>Enter Valid Barcode</span> : ""}


                            </MDBox>
                        </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                        <MDBox component="form" role="form">
                            <MDBox mb={4} xs={12}>
                                <TextField
                                    type="text"
                                    label="Receive Item Quantity"
                                    variant="outlined"
                                    fullWidth
                                    inputProps={{
                                        pattern: "^[a-zA-Z0-9 ]+$",
                                        maxLength: 30
                                    }}
                                    value={values.itemQuantity}
                                    onChange={handleChange("itemQuantity")}

                                />
                                {itemErr ? <span style={errMsg}>Receive Item Quantity can't be Blank</span> : ""}
                            </MDBox>
                        </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                        <MDBox component="form" role="form">
                            <MDBox mb={4} xs={12}>
                                <TextField
                                    type="text"
                                    label="Notes"
                                    variant="outlined"
                                    fullWidth
                                    inputProps={{
                                        pattern: "^[a-zA-Z0-9 ]+$",
                                        maxLength: 30
                                    }}
                                    value={values.notes}
                                    onChange={handleChange("notes")}

                                />
                                {notesErr ? <span style={errMsg}>Notes can't be Blank</span> : ""}
                            </MDBox>
                        </MDBox>
                    </Grid>
                    <Grid item xs={12} md={4} lg={1.2}>
                        <MDButton rel="noreferrer" variant="gradient" color="success" fullWidth
                            onClick={updateStatus}
                        >
                            Save
                        </MDButton>
                    </Grid>

                </Grid>
                <MDBox px={2} >
                    <DataTable
                        Header={false}
                        screenName={false}
                        addNew={false}
                        table={{
                            filterable: true,
                            rows,
                            columns: [
                                {
                                    Header: "No Of Items",
                                    accessor: "numberOfItems",
                                    align: "center",
                                },
                                {
                                    Header: "Cargo Type",
                                    accessor: "cargoType",
                                    align: "center",
                                },
                                {
                                    Header: "Description",
                                    accessor: "description",
                                    align: "left",
                                },
                                {
                                    Header: "Weight (Kg)",
                                    accessor: "weightInKg",
                                    align: "center",
                                },
                                {
                                    Header: "Length (mm)",
                                    accessor: "lengthInMm",
                                    align: "center",
                                },

                                {
                                    Header: "Width (mm)",
                                    accessor: "breadthInMm",
                                    align: "center",
                                },
                                {
                                    Header: "Height (mm)",
                                    accessor: "heightInMm",
                                    align: "center",
                                },
                                {
                                    Header: "Recieved Quantity",
                                    accessor: "receivedQty",
                                    align: "center",
                                },
                                {
                                    Header: "Notes",
                                    accessor: "notes",
                                    align: "center",
                                },

                                {
                                    Header: "Item Status",
                                    accessor: "itemStatus",
                                    align: "center",
                                },

                            ],
                        }}
                        // rows={values.roles}
                        canSearch={false}
                        isSorted={true}
                        entriesPerPage={false}
                        showTotalEntries={false}
                        pagination={true}
                        noEndBorder
                    />
                </MDBox>
            </Card>
            <LoadingModal loading={loading} />
        </DashboardLayout >
    );
}

export default RecieveOrder;
